import { Component } from "@angular/core";
import { AuthService } from "../../services/auth.service";
import { CookieService } from "ngx-cookie-service";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";

@Component({
    selector: "signedout",
    templateUrl: "./signedout.component.html",
    standalone: false
})
export class SignedOutComponent {
    constructor(private authService: AuthService, private cookieService: CookieService, private router: Router) {
    }

    ngOnInit(): void {
        this.authService.accessToken = null as any;
    }

    navigateToSignIn(): void {
       this.router.navigate(["splash"]);
    }
}
